// import axiosConfig from "../axiosConfig";
import { toast } from "react-toastify";
import axiosConfig from "../axiosConfig.js";

class AuthenticationService {
    signInWithPhone = async (credentials) => {
        try {
            const response = await axiosConfig.post("Auth/SignInWithPhone", credentials);
            return response;
        } catch (error) {
            const errorMessage = error?.message || "Object reference not set to an instance of an object"; // Fallback message
            // Show the error message as a toast notification
            toast.error(errorMessage);
            // Re-throw the error for further handling if needed
            throw new Error(error);
        }
    };

    signInWithPhoneVerify = async (verifyCode) => {
        try {
            const response = await axiosConfig.post("Auth/SignInWithPhoneVerify", verifyCode);
            return response;
        } catch (error) {
            const errorMessage = error?.message || "Session expired"; // Fallback message
            // Show the error message as a toast notification
            toast.error(errorMessage);
            // Re-throw the error for further handling if needed
            throw new Error(error);
        }
    };
    
    
    signInWithEmailLink = async (credentials) => {
        try {
            const response = await axiosConfig.post("Auth/SignInWithEmailLink", credentials);
            return response;
        } catch (error) {
            const errorMessage = error?.message || "Object reference not set to an instance of an object"; // Fallback message
            // Show the error message as a toast notification
            toast.error(errorMessage);
            // Re-throw the error for further handling if needed
            throw new Error(error);
        }
    };

    signInWithEmailLinkVerify = async (verifyCode) => {
        try {
            const response = await axiosConfig.post("Auth/SignInWithEmailLinkVerify", verifyCode);
            return response;
        } catch (error) {
            const errorMessage = error?.message || "Session expired"; // Fallback message
            // Show the error message as a toast notification
            toast.error(errorMessage);
            // Re-throw the error for further handling if needed
            throw new Error(error);
        }
    };
    
}

const instance = new AuthenticationService();

export default instance;
